// extracted by mini-css-extract-plugin
export var dropdown = "_qt-0";
export var imageWrapper = "_qt-3";
export var itemNameContainer = "_qt-1";
export var productImage = "_qt-2";
export var spinnerWrapper = "_qt-4";